import React from "react";
import {
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Box,
  Chip,
  TableSortLabel,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactComponent as NoteIcon } from "../../Assets/Icons/PharmsmartIcon/NoteIcon.svg";
import { ReactComponent as EditIcon } from "../../Assets/Icons/PharmsmartIcon/EditIcon.svg";
import { ReactComponent as DeleteIcon } from "../../Assets/Icons/PharmsmartIcon/DeleteIcon.svg";
import "../../Sass/Common.scss";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipMain";
import TableEmptyState from "../../Components/Common/Table/TableEmptyState";
import TableLoadMore from "../../Components/Common/Table/TableLoadMore";
import TableCellLoader from "../../Components/Common/Table/TableCellLoader";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import { useNavigate } from "react-router-dom";
import { getEllipsisName, setLocalStorage } from "../../utils/generalUtils";
import Chips from "../../Components/Common/Chips";
import clsx from "clsx";
const useStyle = makeStyles((theme) => ({
  tableHead: {
    "&>tr": {
      "&>th": {
        "&:first-child": {
          width: "25%",
          [theme.breakpoints.down("xl")]: {
            whiteSpace: "nowrap",
            minWidth: "153px !important",
          },
        },
        "&:nth-child(2)": {
          whiteSpace: "nowrap !important",
          // width: "13%",
          [theme.breakpoints.down("xl")]: {
            // maxWidth: "146px !important",
          },
        },
        "&:nth-child(3)": {
          whiteSpace: "nowrap !important",
          width: "16%",
          [theme.breakpoints.down("1447")]: {
            padding: "16px 34px",
          },
          [theme.breakpoints.down("1386")]: {
            width: "-18% !important",
          },
          [theme.breakpoints.down("1400")]: {
            width: "-18% !important",
          },
          [theme.breakpoints.down("1550")]: {
            width: "-6% !important",
          },
          [theme.breakpoints.down("1920")]: {
            whiteSpace: "nowrap !important",
            width: "10%",
          },
          [theme.breakpoints.down("1777")]: {
            whiteSpace: "nowrap !important",
            width: "12%",
          },
          [theme.breakpoints.down("1600")]: {
            whiteSpace: "nowrap !important",
            width: "13%",
            // padding: "16px 7px",
          },
          [theme.breakpoints.down("1517")]: {
            whiteSpace: "nowrap !important",
            width: "14%",
          },
          [theme.breakpoints.down("1500")]: {
            whiteSpace: "nowrap !important",
            width: "15%",
          },
          [theme.breakpoints.down("1483")]: {
            whiteSpace: "nowrap !important",
            width: "16%",
          },
          [theme.breakpoints.down("1471")]: {
            whiteSpace: "nowrap !important",
            width: "18%",
          },
          [theme.breakpoints.down("1456")]: {
            whiteSpace: "nowrap !important",
            width: "20%",
          },
          [theme.breakpoints.down("1447")]: {
            whiteSpace: "nowrap !important",
            width: "70%",
          },
        },
        "&:nth-child(4)": {
          whiteSpace: "nowrap !important",
          width: "15%",
          [theme.breakpoints.down("1175")]: {
            padding: "2px 15px !important",
          },
        },
        "&:nth-child(5)": {
          whiteSpace: "nowrap !important",
          width: "15%",
        },
        "&:nth-child(6)": {
          whiteSpace: "nowrap !important",
          width: "15%",
        },
        "&:nth-child(7)": {
          whiteSpace: "nowrap !important",
          width: "15%",
        },
        "&:last-child": {
          width: "0% !important",
        },
      },
    },
  },
  tableBody: {
    "&>tr": {
      "&>td": {
        "&:first-child": {
          whiteSpace: "nowrap !important",
        },
      },
    },
  },
  // rsMainChipBox: {
  //   width: "200px ",
  // },
  rsUrgentIconBtn: {
    border: "3 solid",
    borderRadius: "3px !important",
    fontSize: "10px !important",
    height: "24px !important",
    marginLeft: "13px !important",
    marginRight: "3px",
    marginTop: "8px",
    marginBottom: "8px",
    color: "white",
    display: "flex",
    alignItems: "center",
    cursor: "auto",
    "&>span": {
      fontSize: "10px",
      padding: "8px 8px 7px",
      fontWeight: "600 !important",
      color: "white",
      cursor: "auto",
    },
    [theme.breakpoints.down(1500)]: {
      // marginLeft: "0 !important",
      marginTop: "3px",
    },
  },
  rsIconStatus: {
    cursor: "auto",
  },
  tableSort: {
    flexDirection: "row",
    "& .MuiTableSortLabel-icon": {
      opacity: 1,
    },
    "& .MuiTableSortLabel-root.MuiTableSortLabel-active": {
      color: theme.palette.background.red,
    },
  },
  itemWrap: {
    whiteSpace: "nowrap",
    marginTop: "4px",
    cursor: "pointer",
    color: "#2e5aff",
  },
  rsSurgeryTableChip: {
    "&>span": {
      color: "#3e3e3e",
    },
    marginRight: "10px !important",
  },
  rsSurgeryNameAlign: {
    marginRight: "8px",
    // textDecoration: "underline",
    color: "#464646 !important",
    "&:hover": {
      color: "rgba(90, 104, 114, 0.8) !important",
      cursor: "pointer",
    },
    "&>div": {
      marginLeft: "10px",
    },
  },
  iconBtn: {
    margin: "2px 0 -4px !important",
    borderRadius: "10% !important",
    width: "61px !important",
    height: "19px",
  },
  rsOrderDatePhone: {
    whiteSpace: "nowrap",
    "&:hover": {
      lineHeight: "24px",
      cursor: "pointer",
      "&>button": {
        padding: "0px !important",
        "&:hover": {
          backgroundColor: "transparent !important",
          border: `none !important`,
        },
        "&>svg": {
          display: "block",
        },
      },
    },
  },
  rsOrderDate: {
    whiteSpace: "nowrap",
    lineHeight: "24px",
    display: "flex",
    flexDirection: "row",
    minWidth: "270px",
    // width:"auto",
    "&>span": {
      "&>p": {
        width: "230px",
        // width:"fit-content",
      },
    },
    "&:hover": {
      lineHeight: "24px",
      cursor: "pointer",
      "&>button": {
        padding: "0px !important",
        "&:hover": {
          backgroundColor: "transparent !important",
          border: `none !important`,
        },
        "&>svg": {
          display: "block",
        },
      },
    },
  },
  rsDriverAddMe: {
    "&>div": {
      height: "25px !important",
      borderRadius: "3px !important",
      lineHeight: "31px !important",
      "&:hover": {
        background: "rgba(123, 192,  68,0.08) !important",
        cursor: "pointer",
      },
    },
    "&:hover": {
      lineHeight: "20px",
      cursor: "pointer",
      "&>button": {
        padding: "0px !important",
        "&:hover": {
          backgroundColor: "transparent !important",
          border: `none !important`,
        },
        "&>svg": {
          display: "block",
        },
      },
    },
  },
  rseditDateIconPhone: {
    "&>svg": {
      // marginLeft: 10,
      display: "none",
    },
  },
  rsOrderDatePhone: {
    whiteSpace: "nowrap",
    "&:hover": {
      lineHeight: "24px",
      cursor: "pointer",
      "&>button": {
        padding: "0px !important",
        "&:hover": {
          backgroundColor: "transparent !important",
          border: `none !important`,
        },
        "&>svg": {
          display: "block",
        },
      },
    },
  },
  rsDriver: {
    whiteSpace: "nowrap",
    lineHeight: "24px",
    padding: "2px 15px !important",
    "&>div": {
      display: "flex",
    },
    "&:hover": {
      "&>button": {
        padding: "0px !important",
        "&:hover": {
          backgroundColor: "transparent !important",
          border: `none !important`,
        },
        "&>svg": {
          display: "block",
        },
      },
    },
  },
  rseditDateIcon: {
    lineHeight: "20px",
    "&>svg": {
      marginLeft: "13px",
      display: "none",
      height: "18px",
      width: "18px",
      "&>path": {
        fill: "transparent !important",
      },
    },
  },
  rsEditAddress: {
    padding: "0px !important",
    width: "18px",
    height: "18px",
    "&>svg": {
      // marginLeft: 10,
      display: "none",
    },
  },
  rsSurgeryTableWorkChip: {
    marginRight: "10px !important",
    marginTop: "3px !important",
    marginBottom: " 3px !important",
    height: "20px !important",
    // width: "50px !important",
    // padding:"2px !important",
    color: "#3e3e3e !important",
    "&>div": {
      "&>span": {
        padding: "0px !important",
      },
    },
    [theme.breakpoints.between(1800, 1925)]: {
      padding: "0px !important",
    },
    [theme.breakpoints.down(1925)]: {
      marginRight: "3px !important",
      marginTop: "3px !important",
      marginBottom: " 3px !important",
      height: "20px !important",
      width: "36px !important",
      "& .MuiChip-label": {
        padding: "5px 0px 5px 0px",
        textOverflow: "unset",
        fontSize: "12px",
      },
    },
  },
  Address: {
    width: "250px",
    whiteSpace: "normal",
    fontSize: "0.875rem !important",
  },
  rsAddressTableCell: {
    padding: "2px 10px 2px 20px !important",
  },
}));

const SurgeryTable = ({
  surgeryList,
  columnSortingOrder,
  setColumnSortingOrder,
  defaultColumnOrderBy,
  setSurgeryRecordActionType,
  setShowNoteList,
  setOpenNoteList,
  setEditSurgeryData,
  setIsOpenSurgeryModel,
  setDeleteSurgery,
  setSurgeryDeleteId,
  setPatientCount,
  setTarget,
  showDataBasedOnRole,
  tableCells,
  setIsOpenEditDateModel,
  setEditRepeatDate,
  setCol,
  checkedCollection,
  changeDropDownValue,
  searchValue,
}) => {
  const classes = useStyle();
  const navigate = useNavigate();
  const showLoaderValue = Object.values(tableCells).filter((item) => {
    return item;
  });

  return (
    <>
      <TableContainer>
        <Table stickyHeader>
          <TableHead className={classes.tableHead}>
            {["pharmacist_staff", "pharmacy"].indexOf(showDataBasedOnRole) !==
              -1 ? (
              <TableRow>
                {Object.keys(tableCells).map((headCell) => (
                  <>
                    {tableCells[headCell].show && (
                      <>
                        {tableCells[headCell].sortable === true ? (
                          <TableCell
                            key={tableCells[headCell].id}
                            padding={
                              tableCells[headCell].disablePadding
                                ? "none"
                                : "default"
                            }
                          >
                            <TableSortLabel
                              sx={{
                                "&.MuiTableSortLabel-root": {
                                  color: "white",
                                },
                                "& .MuiTableSortLabel-icon": {
                                  color:
                                    columnSortingOrder.orderBy ===
                                      tableCells[headCell].id
                                      ? "#525252 !important"
                                      : "#C5C5C5 !important",
                                  "&.MuiTableSortLabel-iconDirectionDesc": {
                                    color: "#525252 !important",
                                  },
                                  "& .MuiTableSortLabel-iconDirectionAsc": {
                                    color:
                                      columnSortingOrder.orderBy ===
                                        tableCells[headCell].id
                                        ? "#525252 !important"
                                        : "#C5C5C5 !important",
                                  },
                                },
                              }}
                              className={classes.tableSort}
                              direction={
                                columnSortingOrder.orderBy ===
                                  tableCells[headCell].id
                                  ? columnSortingOrder.sortBy
                                  : defaultColumnOrderBy
                              }
                              onClick={(e) => {
                                setColumnSortingOrder({
                                  orderBy: tableCells[headCell].id,
                                  sortBy:
                                    (columnSortingOrder.orderBy ===
                                      tableCells[headCell].id
                                      ? columnSortingOrder.sortBy
                                      : defaultColumnOrderBy) === "desc"
                                      ? "asc"
                                      : "desc",
                                });
                              }}
                            >
                              {tableCells[headCell].label}
                            </TableSortLabel>
                          </TableCell>
                        ) : (
                          <TableCell> {tableCells[headCell].label}</TableCell>
                        )}
                      </>
                    )}
                  </>
                ))}
              </TableRow>
            ) : (
              <TableRow>
                {Object.keys(tableCells).map((headCell) => (
                  <>
                    {tableCells[headCell].show && (
                      <>
                        {tableCells[headCell].sortable === true ? (
                          <TableCell
                            key={tableCells[headCell].id}
                            padding={
                              tableCells[headCell].disablePadding
                                ? "none"
                                : "default"
                            }
                          >
                            <TableSortLabel
                              sx={{
                                "&.MuiTableSortLabel-root": {
                                  color: "white",
                                },
                                "& .MuiTableSortLabel-icon": {
                                  color:
                                    columnSortingOrder.orderBy ===
                                      tableCells[headCell].id
                                      ? "#525252 !important"
                                      : "#C5C5C5 !important",
                                  "&.MuiTableSortLabel-iconDirectionDesc": {
                                    color: "#525252 !important",
                                  },
                                  "& .MuiTableSortLabel-iconDirectionAsc": {
                                    color:
                                      columnSortingOrder.orderBy ===
                                        tableCells[headCell].id
                                        ? "#525252 !important"
                                        : "#C5C5C5 !important",
                                  },
                                },
                              }}
                              className={classes.tableSort}
                              direction={
                                columnSortingOrder.orderBy ===
                                  tableCells[headCell].id
                                  ? columnSortingOrder.sortBy
                                  : defaultColumnOrderBy
                              }
                              onClick={(e) => {
                                setColumnSortingOrder({
                                  orderBy: tableCells[headCell].id,
                                  sortBy:
                                    (columnSortingOrder.orderBy ===
                                      tableCells[headCell].id
                                      ? columnSortingOrder.sortBy
                                      : defaultColumnOrderBy) === "desc"
                                      ? "asc"
                                      : "desc",
                                });
                              }}
                            >
                              {tableCells[headCell].label}
                            </TableSortLabel>
                          </TableCell>
                        ) : (
                          <TableCell
                            className={
                              tableCells[headCell].label === "ACTIONS"
                                ? "table-action"
                                : ""
                            }
                          >
                            {" "}
                            {tableCells[headCell].label}
                          </TableCell>
                        )}
                      </>
                    )}
                  </>
                ))}
              </TableRow>
            )}
          </TableHead>
          <TableBody className={classes.tableBody}>
            {surgeryList?.loading ? (
              <TableCellLoader
                cells={
                  showLoaderValue.filter(({ show }) => show === true).length
                }
              />
            ) : surgeryList?.data?.list?.length > 0 ? (
              surgeryList?.data?.list?.map((item, i) => {
                return (
                  <>
                    <TableRow key={i}>
                      <TableCell semiBold>
                        <Box
                          className={classes.rsSurgeryNameAlign}
                          onClick={() => {
                            const encodedData = encodeURIComponent(
                              JSON.stringify({
                                id: item.id,
                                name: item.name,
                                email: item.email,
                              })
                            );
                            navigate(
                              `${process.env.REACT_APP_USE_PRESCRIPTION_TRACKING == "true" ? "/prescription-tracking" : "/rx-collection"}?from=surgeries&action=click&data=${encodedData}`
                              , {
                                state: {
                                  isSurgeryListModule: true
                                }
                              });
                            setLocalStorage(
                              "uncollectPrescription",
                              checkedCollection
                            );
                            setLocalStorage("driver", changeDropDownValue);
                            setLocalStorage("surgerySearch", searchValue);
                          }}
                        >
                          {item?.name}
                          {item?.is_urgent ? (
                            // <Chip
                            //   className={classes.rsUrgentIconBtn}
                            //   label="Urgent"
                            //   style={{
                            //     backgroundColor: "red",
                            //     cursor: "auto",
                            //   }}
                            // />
                            <>
                              {" "}
                              <Box className={clsx("urgent_effect")}></Box>
                              <Chips
                                label="Urgent"
                                color={"#e9514e"}
                                variant="filled"
                                textColor="white"
                                borderColorChip="#e9514e"
                                className={classes.rsUrgentIconBtn}
                                width="58px"
                              // <Chip
                              //   className={classes.rsUrgentIconBtn}
                              //   label="Urgent"
                              //   style={{
                              //     backgroundColor: "red",
                              //     cursor: "auto",
                              //   }}
                              // />
                              />
                            </>
                          ) : (
                            <></>
                          )}
                        </Box>
                      </TableCell>
                      {Object.keys(tableCells).map((columnName) => {
                        return (
                          <>
                            {tableCells[columnName].show && (
                              <>
                                {!["pharmacist_staff", "pharmacy"].indexOf(
                                  showDataBasedOnRole
                                ) !== -1 &&
                                  columnName === "pharmacy_collection" && (
                                    <TableCell>
                                      {item?.pharmacy_collection || "-"}
                                    </TableCell>
                                  )}
                                {columnName === "driver" && (
                                  <>
                                    {showDataBasedOnRole === "user" ? (
                                      <TableCell>
                                        <Box>
                                          {item?.driver ? (
                                            <div className="tooltipStyle">
                                              {item?.driver
                                                .slice(0, 1)
                                                .map((wpDayList, index) => {
                                                  return (
                                                    <Chip
                                                      label={
                                                        item?.driver[index].name
                                                      }
                                                      variant="contained"
                                                      size="small"
                                                      className={
                                                        classes.rsSurgeryTableChip
                                                      }
                                                    />
                                                  );
                                                })}
                                              {item?.driver?.length > 0 ? (
                                                <HtmlTooltipMain
                                                  interactive={true}
                                                  title={
                                                    <Grid>
                                                      {item?.driver
                                                        ?.slice(1)
                                                        .map(
                                                          (option, index) => (
                                                            <Box>
                                                              {option.name}
                                                            </Box>
                                                          )
                                                        )}
                                                    </Grid>
                                                  }
                                                >
                                                  <div
                                                    className={classes.itemWrap}
                                                  >
                                                    {item?.driver?.length - 1 >
                                                      0
                                                      ? ` +
                                                          ${item?.driver
                                                        ?.length -
                                                      Math.min(
                                                        1,
                                                        item?.driver
                                                          ?.length
                                                      )
                                                      }
                                                          more`
                                                      : ""}
                                                  </div>
                                                </HtmlTooltipMain>
                                              ) : (
                                                "-"
                                              )}
                                            </div>
                                          ) : (
                                            "N / A"
                                          )}
                                        </Box>
                                      </TableCell>
                                    ) : (
                                      <TableCell className={classes.rsDriver}>
                                        {showDataBasedOnRole !== "user" && (
                                          <>
                                            <div>
                                              {item?.driver
                                                .slice(0, 2)
                                                .map((wpDayList, index) => {
                                                  return (
                                                    <Chip
                                                      label={
                                                        item?.driver[index].name
                                                      }
                                                      variant="contained"
                                                      size="small"
                                                      className={
                                                        classes.rsSurgeryTableChip
                                                      }
                                                    />
                                                  );
                                                })}
                                              <>
                                                {item?.driver?.length - 1 >
                                                  0 ? (
                                                  <>
                                                    <HtmlTooltipMain
                                                      interactive={true}
                                                      title={
                                                        <Grid>
                                                          {item?.driver
                                                            ?.slice(2)
                                                            .map(
                                                              (
                                                                option,
                                                                index
                                                              ) => (
                                                                <Box>
                                                                  {option.name}
                                                                </Box>
                                                              )
                                                            )}
                                                        </Grid>
                                                      }
                                                    >
                                                      <div>
                                                        {/* {` +
                                                        ${
                                                          item?.driver?.length -
                                                          Math.min(
                                                            2,
                                                            item?.driver?.length
                                                          )
                                                        }
                                                        `} */}
                                                        {item?.driver?.length -
                                                          Math.min(
                                                            2,
                                                            item?.driver?.length
                                                          ) !==
                                                          0 && (
                                                            <div
                                                              className={
                                                                classes.itemWrap
                                                              }
                                                            >
                                                              {` + ${item?.driver
                                                                ?.length -
                                                                Math.min(
                                                                  2,
                                                                  item?.driver
                                                                    ?.length
                                                                )
                                                                } `}
                                                            </div>
                                                          )}
                                                      </div>
                                                    </HtmlTooltipMain>
                                                  </>
                                                ) : (
                                                  <>
                                                    <Box
                                                      className={clsx(
                                                        classes.rsDriverAddMe
                                                      )}
                                                    >
                                                      {" "}
                                                      {item?.driver?.length ===
                                                        0 && (
                                                          <>
                                                            <Box
                                                              className={clsx(
                                                                "addme_effect"
                                                              )}
                                                            ></Box>
                                                            <Chips
                                                              label="Add me"
                                                              color={
                                                                "rgba(123, 192,  68,1)"
                                                              }
                                                              variant={"filled"}
                                                              textColor={
                                                                "rgba(255,255,255,1)"
                                                              }
                                                              borderColorChip={
                                                                "rgba(123, 192,  68,1)"
                                                              }
                                                              // color={""}
                                                              // variant={"outlined"}
                                                              // borderColorChip={
                                                              //   "rgba(123, 192,  68,1)"
                                                              // }
                                                              // textColor={
                                                              //   "rgba(123, 192, 68,1)"
                                                              // }
                                                              width="58px"
                                                              onClick={() => {
                                                                setCol(
                                                                  "addDriverFilter"
                                                                );
                                                                setEditRepeatDate(
                                                                  item
                                                                );
                                                                setIsOpenEditDateModel(
                                                                  true
                                                                );
                                                              }}
                                                            />
                                                          </>
                                                        )}
                                                    </Box>
                                                  </>
                                                )}
                                              </>
                                            </div>
                                          </>
                                        )}
                                      </TableCell>
                                    )}
                                  </>
                                )}
                                {columnName === "driver_goes_days" && (
                                  <TableCell>
                                    <Box className={classes.rsMainChipBox}>
                                      {item?.driver_goes_days?.length > 0 ? (
                                        <>
                                          {item?.driver_goes_days.map(
                                            (wpDayList, index) => {
                                              return (
                                                <HtmlTooltipMain
                                                  title={wpDayList.day}
                                                >
                                                  <Chip
                                                    label={wpDayList.day.substr(
                                                      0,
                                                      3
                                                    )}
                                                    variant="contained"
                                                    size="small"
                                                    className={
                                                      classes.rsSurgeryTableWorkChip
                                                    }
                                                  />
                                                </HtmlTooltipMain>
                                              );
                                            }
                                          )}
                                        </>
                                      ) : (
                                        <>-</>
                                      )}
                                    </Box>
                                  </TableCell>
                                )}
                                {columnName === "address" && (
                                  <>
                                    {showDataBasedOnRole === "user" ? (
                                      <TableCell>
                                        <Box>
                                          {item?.address
                                            ? item?.address
                                            : "N / A"}
                                        </Box>
                                      </TableCell>
                                    ) : (
                                      <TableCell
                                        className={clsx(
                                          classes.rsAddressTableCell,
                                          classes.rsOrderDate
                                        )}
                                      >
                                        <Box className={classes.rsOrderDate}>
                                          {showDataBasedOnRole !== "user" && (
                                            <HtmlTooltipMain
                                              title={item?.address}
                                            >
                                              <span>
                                                {item?.address ? (
                                                  // ? getEllipsisName(
                                                  //     item?.address,
                                                  //     20
                                                  //   )
                                                  <Typography
                                                    className={classes.Address}
                                                  >
                                                    {item?.address}
                                                  </Typography>
                                                ) : (
                                                  !item?.address && (
                                                    <>
                                                      <Box
                                                        className={clsx(
                                                          "addme_effect"
                                                        )}
                                                      ></Box>
                                                      <Box
                                                        className={
                                                          classes.rsDriverAddMe
                                                        }
                                                      >
                                                        <Chips
                                                          label="Add me"
                                                          color={
                                                            "rgba(123, 192,  68,1)"
                                                          }
                                                          variant="filled"
                                                          textColor="rgba(255,255,255,1)"
                                                          borderColorChip="rgba(123, 192,  68,1)"
                                                          // color={""}
                                                          // variant={"outlined"}
                                                          // borderColorChip={
                                                          //   "rgba(123, 192,  68,1)"
                                                          // }
                                                          // textColor={
                                                          //   "rgba(123, 192, 68,1)"
                                                          // }
                                                          style={{
                                                            borderRadius:
                                                              "7px !important",
                                                          }}
                                                          width="58px"
                                                          onClick={() => {
                                                            setCol(
                                                              "newAddress"
                                                            );
                                                            setEditRepeatDate(
                                                              item
                                                            );
                                                            setIsOpenEditDateModel(
                                                              true
                                                            );
                                                          }}
                                                        />
                                                      </Box>
                                                    </>
                                                  )
                                                )}
                                              </span>
                                            </HtmlTooltipMain>
                                          )}
                                          {showDataBasedOnRole !== "user" && (
                                            <>
                                              {item?.address?.length > 0 && (
                                                <IconButton
                                                  className={
                                                    classes.rseditDateIcon
                                                  }
                                                >
                                                  <PrimaryIcon
                                                    color="secondary"
                                                    width="20px"
                                                    icon={EditIcon}
                                                    cursor="pointer"
                                                    onClick={() => {
                                                      setCol("address");
                                                      setEditRepeatDate(item);
                                                      setIsOpenEditDateModel(
                                                        true
                                                      );
                                                    }}
                                                  />
                                                </IconButton>
                                              )}
                                            </>
                                          )}
                                        </Box>
                                      </TableCell>
                                    )}
                                  </>
                                )}
                                {columnName === "no_of_collection" && (
                                  <TableCell>
                                    {item?.collection_count
                                      ? item?.collection_count
                                      : "-"}
                                  </TableCell>
                                )}
                                {columnName === "best_ordering_method" && (
                                  <TableCell>
                                    {item?.ordering_method
                                      ? item?.ordering_method
                                      : "-"}
                                  </TableCell>
                                )}
                                {columnName === "phone_no" && (
                                  <TableCell
                                    className={
                                      showDataBasedOnRole === "user"
                                        ? ""
                                        : classes.rsOrderDatePhone
                                    }
                                  >
                                    {item?.phone ? item?.phone : "N / A"}
                                    {` `}
                                    {showDataBasedOnRole !== "user" && (
                                      <IconButton
                                        className={
                                          // showDataBasedOnRole !== "user"
                                          //   ? classes.rseditDateIconPhone
                                          // :
                                          classes.rseditDateIcon
                                        }
                                      >
                                        <PrimaryIcon
                                          color="secondary"
                                          width="20px"
                                          icon={EditIcon}
                                          cursor="pointer"
                                          onClick={() => {
                                            setCol("phone");
                                            setEditRepeatDate(item);
                                            setIsOpenEditDateModel(true);
                                          }}
                                        />
                                      </IconButton>
                                    )}
                                  </TableCell>
                                )}
                              </>
                            )}
                          </>
                        );
                      })}
                      <TableCell className="table-action">
                        <Box display={"flex"} fontWeight="300">
                          <HtmlTooltipMain title="View Notes">
                            <IconButton
                              className="hoverAlign"
                              onClick={() => {
                                setShowNoteList(item?.id);
                                setOpenNoteList(true);
                              }}
                            >
                              <PrimaryIcon
                                width="20px"
                                icon={NoteIcon}
                                cursor="pointer"
                              />
                            </IconButton>
                          </HtmlTooltipMain>
                          {showDataBasedOnRole !== "user" && (
                            <>
                              <HtmlTooltipMain title="Edit Surgery">
                                <IconButton
                                  className="hoverAlign"
                                  onClick={() => {
                                    setSurgeryRecordActionType(
                                      "editSurgeryDetail"
                                    );
                                    setEditSurgeryData(item);
                                    setIsOpenSurgeryModel(true);
                                  }}
                                >
                                  <PrimaryIcon
                                    color="primary"
                                    width="20px"
                                    icon={EditIcon}
                                    cursor="pointer"
                                  />
                                </IconButton>
                              </HtmlTooltipMain>
                              <HtmlTooltipMain title="Delete Surgery">
                                <IconButton
                                  className="hoverAlign"
                                  onClick={() => {
                                    setDeleteSurgery(true);
                                    setSurgeryDeleteId(item?.id);
                                    setPatientCount(item?.patient_count);
                                  }}
                                >
                                  <PrimaryIcon
                                    width="20px"
                                    icon={DeleteIcon}
                                    cursor="pointer"
                                  />
                                </IconButton>
                              </HtmlTooltipMain>
                            </>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  </>
                );
              })
            ) : (
              <TableEmptyState />
            )}
            {surgeryList?.data?.list?.length !=
              surgeryList?.data?.filterd_record && (
                <TableLoadMore setRef={setTarget} />
              )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default SurgeryTable;
